'use client';

import { useEffect, useState } from 'react';
import styles from './pageloading.module.scss';

const IMG_URL = '/resources/images/Stella-TailWag-v5.gif';

export default function PageLoading() {
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        let counter = 0;
        const interval = 100;
        const maxCounter = 3000 / interval;

        const sfInterval = setInterval(() => {
            const clientWindow = window as BrowserWindow;
            const campaigns = clientWindow.SalesforceInteractions?.mcis?.getCampaignResponses();

            if (campaigns) {
                document.body.classList.remove('loading');
                setHidden(true);
                clearInterval(sfInterval);
            } else if (counter >= maxCounter) {
                document.body.classList.remove('loading');
                setHidden(true);
                clearInterval(sfInterval);
            }

            counter += 1;
        }, interval);
        return () => {
            clearInterval(sfInterval);
        };
    }, []);

    return (
        <div
            className={styles.pageLoadOverlay}
            role="alert"
            aria-busy={!hidden}
            aria-label="Loading"
            aria-hidden={hidden}
        >
            <link rel="preload" as="image" fetchPriority="high" href={IMG_URL} />
        </div>
    );
}
